import {lazyLoad} from "../../../../utils/loadable";

export const ShoutoutAwardsPreview = lazyLoad(
  () => import('./index'),
  module => module.ShoutoutAwardsPreviewPage,
);
